import {useId} from 'react';
import {twMerge} from 'tailwind-merge';

import CheckMark from '@/assets/icons/check-mark.svg?react';
import ErrorOutlined from '@/assets/icons/error-outlined.svg?react';

import Label from '../Label';
import TextInput, {TextInputProps} from '../TextInput';

type FormInputProps = {
  label: string;
  inputProps: Omit<TextInputProps, 'id' | 'className'>;
  showValidationIcon?: boolean;
  error?: string;
};

function FormField({
  label,
  inputProps,
  showValidationIcon,
  error,
}: FormInputProps) {
  const htmlFor = useId();

  return (
    <div className="flex flex-col gap-1">
      <Label
        htmlFor={htmlFor}
        className="font-semibold text-dark-gray text-xs sm:text-sm"
      >
        {label}
      </Label>
      <div className="relative">
        <TextInput
          id={htmlFor}
          className={twMerge(
            'h-[50px] rounded-lg border border-inactive bg-white px-3.5 py-3 text-black text-lg focus:border-link sm:h-[60px] sm:text-xl',
            showValidationIcon && 'pr-10',
            Boolean(error) && 'border-error focus:border-error'
          )}
          {...inputProps}
        />
        {showValidationIcon && Boolean(error) && (
          <ErrorOutlined className="absolute top-1/2 right-3 size-6 shrink-0 -translate-y-1/2" />
        )}
        {showValidationIcon && Boolean(!error) && (
          <CheckMark className="absolute top-1/2 right-3 size-6 shrink-0 -translate-y-1/2 fill-lime-green" />
        )}
      </div>
      <p className="text-error text-xs empty:hidden">{error}</p>
    </div>
  );
}

export default FormField;
